const FormValue = require('../modules/form-value');
const FileRequest = require('../request/file-request');
const ToggleAnime = require('../velocity/toggle-anime');

/**
 * Simulation
 * @class
 */
class Simulation {

  elms = {
    btnClass        : 'js-simulation-btn',
    loaderClass     : 'js-simulation-loader',
    inputKwhClass   : 'js-simulation-input-kwh',
    inputHiddenClass: 'js-simulation-input-hidden',
  };
  apiUrl = '/_json/simulation.json';
  isCorrectClass = 'is-correct';

  /**
   * @instance
   * @param _$el {HTMLElement}
   * @param _opts {object}
   */
  constructor(_$el, _opts) {
    this.$btn          = _$el.getElementsByClassName(this.elms.btnClass)[0];
    this.$loader       = _$el.getElementsByClassName(this.elms.loaderClass)[0];
    this.$$inputKwh    = document.getElementsByClassName(this.elms.inputKwhClass);
    this.$$inputHidden = document.getElementsByClassName(this.elms.inputHiddenClass);
    this.$$input       = _$el.querySelectorAll('input, textarea');

    this.modalId = _opts.modalId;

    this.createAnime();

    this.FileRequest = new FileRequest(this.apiUrl, {
      method: 'post',
    });
    this.formValue = new FormValue(_$el);
  }

  /**
   * @instance
   */
  run() {
    _.forEach(this.$$input, (_$el) => {
      _$el.blur();
    });

    setTimeout(() => {
      if(!this.$btn.classList.contains(this.isCorrectClass)) return;

      const values_ = this.formValue.get();

      this.toggleLoader.run(true);

      this.FileRequest.request({
        body: JSON.stringify(values_),
      })
      .then( (_data) => {
        this.toggleLoader.run(false);
        this.setHiddenValue(values_);
        this.setKwhValue(_data);
        _.forEach(this.$$inputKwh, (_$el) => {
          _$el.dispatchEvent(new CustomEvent('blur'));
        });
        modalWindow.open(this.modalId);
      });
    }, 0);
  }

  /**
   * @instance
   * @private
   */
  createAnime() {
    this.toggleLoader = new ToggleAnime({
      $el: this.$loader,
      anime: [ 'fadeIn', 'fadeOut' ],
      opts: {
        duration: 200,
        easing  : 'linear',
      },
    });
  }

  /**
   * @instance
   * @private
   * @param _data {array}
   */
  setKwhValue(_data) {
    _.forEach(this.$$inputKwh, (_$el, i) => {
      _$el.value = _data[i];
    });
  }

  /**
   * @instance
   * @private
   * @param _data {object}
   */
  setHiddenValue(_data) {
    _.forEach(this.$$inputHidden, (_$el) => {
      _.forEach(_data, (_val, _key) => {
        if(_key === _$el.name) {
          _$el.value = _val;
        }
      });
    });
  }

}

/**
 * class exports
 */
module.exports = Simulation;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/simulation.js
 **/